import React from "react";

const getEmptyPageMetadata = () => {
  return {
    previousPageTokens: [],
    nextPageToken: null,
  };
};

const getCurrentPageTokenForPageRead = (pageMetadata, dispatch) => {
  const currentPageToken =
    pageMetadata.previousPageTokens.length > 0
      ? pageMetadata.previousPageTokens.pop()
      : null;

  dispatch({
    type: "SET_PREVIOUS_PAGE_TOKENS",
    previousPageTokens: pageMetadata.previousPageTokens,
  });

  return currentPageToken;
};

const getPreviousPageTokenForPageRead = (pageMetadata, dispatch) => {
  let prevPageToken = null;
  if (pageMetadata.previousPageTokens.length > 1) {
    pageMetadata.previousPageTokens.pop(); //  Pop current token first
    prevPageToken = pageMetadata.previousPageTokens.pop();
  }
  dispatch({
    type: "SET_PREVIOUS_PAGE_TOKENS",
    previousPageTokens: [...pageMetadata.previousPageTokens],
  });

  return prevPageToken;
};

const isNullOrEmpty = (value) => {
  return !(value && value.length > 0);
};

const pagingReducer = (state, action) => {
  switch (action.type) {
    case "ON_PAGE_READ_SUCCESS":
      if (isNullOrEmpty(action.currentPageToken))
        state = getEmptyPageMetadata();
      else state.previousPageTokens.push(action.currentPageToken);

      state.nextPageToken = isNullOrEmpty(action.nextPageToken)
        ? null
        : action.nextPageToken;

      return { ...state };
    case "SET_PREVIOUS_PAGE_TOKENS":
      state.previousPageTokens =
        action.previousPageTokens && action.previousPageTokens.length > 0
          ? [...action.previousPageTokens]
          : [];
      return { ...state };
    default:
      return state;
  }
};

export {
  getEmptyPageMetadata,
  getCurrentPageTokenForPageRead,
  getPreviousPageTokenForPageRead,
  pagingReducer,
};
